import React, { ReactNode, useState } from 'react';

interface TooltipProps {
  content: string;
  children: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  contentClass?: string;
}

const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  position = 'top',
  contentClass
}) => {
  const [visible, setVisible] = useState(false);

  const getPositionClasses = () => {
    switch (position) {
      case 'bottom':
        return 'top-full mt-2 left-1/2 -translate-x-1/2';
      case 'left':
        return 'right-full mr-2 top-1/2 -translate-y-1/2';
      case 'right':
        return 'left-full ml-2 top-1/2 -translate-y-1/2';
      case 'top':
      default:
        return 'bottom-full mb-2 left-1/2 -translate-x-1/2';
    }
  };

  const getArrowClasses = () => {
    switch (position) {
      case 'bottom':
        return 'top-0 left-1/2 -translate-x-1/2 -translate-y-full border-b-white';
      case 'left':
        return 'right-0 top-1/2 -translate-y-1/2 translate-x-full border-l-white';
      case 'right':
        return 'left-0 top-1/2 -translate-y-1/2 -translate-x-full border-r-white';
      case 'top':
      default:
        return 'bottom-0 left-1/2 -translate-x-1/2 translate-y-full border-t-white';
    }
  };

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div
          className={`absolute z-50 px-2 py-2 text-[12px] text-[#025963] bg-white rounded-lg shadow transition-opacity duration-200 opacity-80 ${getPositionClasses()} ${contentClass? contentClass : ''}`}
        >
          {content}
          <div
            className={`absolute w-0 h-0 border-8 border-transparent ${getArrowClasses()}`}
          />
        </div>
      )}
    </div>
  );
};

export default Tooltip;

